import React, { useEffect, useState } from "react";
import "./index.css";
import AOS from "aos";
import "aos/dist/aos.css";

// Icons
import SmartIcon from "../../../../ASSETS/IMAGES/sb.png";
import CardioIcon from "../../../../ASSETS/IMAGES/cardio.png";
import NeuroIcon from "../../../../ASSETS/IMAGES/neuro.png";
import AllergyIcon from "../../../../ASSETS/IMAGES/allergy.png";
import LiverScanIcon from "../../../../ASSETS/IMAGES/liverscan.png";
// import FibroScanIcon from "../../../../ASSETS/IMAGES/fibroscan.png";
import NeuroFeedbackIcon from "../../../../ASSETS/IMAGES/neurofeedback12.png";
import UltrasoundIcon from "../../../../ASSETS/IMAGES/ultrasound.png";
import RemotePatientIcon from "../../../../ASSETS/IMAGES/rpm.png";

// Images
import SmartImg from "../../../../ASSETS/ICONS/sb-logo.png";
import CardioImg from "../../../../ASSETS/IMAGES/cardio.png";
import NeuroImg from "../../../../ASSETS/IMAGES/neuro.png";
import AllergyImg from "../../../../ASSETS/IMAGES/allergy.png";

const serviceCards = [
  {
    title: "SmartBeat Diagnostic Screening",
    icon: SmartIcon,
    image: SmartImg,
    description: "Our complete cardiac screening program that summarizes results from Ultrasounds of the Aorta and the Carotid, Electrocardiogram, Ultrasound of the heart and various Noninvasive Physiologic Studies of Upper Extremity Arteries into our proprietary algorithm to provide early and actionable test results for physicians to create a treatment plan for their patients. The test takes about 1 hour and is reimbursed by insurance upon meeting certain risk factors and with a physician work order.",
  },
  {
    title: "Cardiovascular Assessment",
    icon: CardioIcon,
    image: CardioImg,
    description: "The Cardiovascular Assessment tests Autonomous nervous system, Sudometer function, Arterial Brachial Index, Heart Rate Variability for the related qualifying conditions like Diabetes, Hypertension, Hyperlipidemia, Heart Irregularities, Dizziness, Anxiety, Neuropathy and Peripheral Vascular disease. The test takes 30 mins and is reimbursed by insurance upon meeting certain risk factors and with a physician work order."
  },
  {
    title: "Neurological Assessment",
    icon: NeuroIcon,
    image: NeuroImg,
    description: "The Neurological Assessment measures Electroencephalogram Activity of The Brain, Electrocardiogram Activity of The Heart, Visual and Auditory Processing Speeds (evoked potentials) and Subjective Neuropsychological Survey for the related qualifying conditions like Memory loss, Seizures, Cognitive Impairment, Dizziness and Stress Related Conditions - Anxiety, Depression, Post traumatic disorder & Chronic Pain. The Test takes 30 mins and is eligible for Insurance reimbursement upon meeting eligibility criteria and in certain cases pre-authorization may be required."
  },
  {
    title: "Allergy Testing & Immunotherapy",
    icon: AllergyIcon,
    image: AllergyImg,
    description: "Allergy Testing & Immunotherapy  sreening program tests 72 different regional environmental allergens including Trees, Grasses, Weeds, Molds, Epithelial for the related qualifying conditions of Allergic Rhinitis, Chronic Sinus infections, Seasonal Allergy Symptoms, Chronic Tinnitus, Asthma, Wheezing and Upper Respiratory infections. The test takes 4 hrs and is reimbursed by insurance with a physician work order."
  },
];

const newserviceCards = [
  { title: "Neuro Feedback", icon: NeuroFeedbackIcon, image: NeuroFeedbackIcon, description: ["Coming Soon"] },
  { title: "Ultrasound", icon: UltrasoundIcon, image: UltrasoundIcon, description: ["Coming Soon"] },
  { title: "Remote Patient Monitoring", icon: RemotePatientIcon, image: RemotePatientIcon, description: ["Coming Soon"] },
  { title: "Liver / Fibro Scan", icon: LiverScanIcon, image: LiverScanIcon, description: ["Coming Soon"] },
  // { title: "Fibro Scan", icon: FibroScanIcon, image: FibroScanIcon, description: ["Coming Soon"] },
];

const ScreeningSection = () => {
  const [activeService, setActiveService] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 900, once: true });
  }, []);

  return (
    <div className="screening-section">

      {/* Title */}
      <h1 className="screening-title" data-aos="fade-up">
        Screening Programs
      </h1>
      <p className="screening-subtitle" data-aos="fade-up" data-aos-delay="100">
        Innovation Focused – Redefining Preventive Care Through Technology
      </p>

      {/* Active Section */}
      <h2 className="section-label">Active Screening Programs</h2>

      <div className="screening-grid">
        {serviceCards.map((item, i) => (
          <div className="program-card" key={i} data-aos="fade-up" onClick={() => setActiveService(item)}>
            <img src={item.image} alt={item.title} className="program-image" />
            <h3 className="program-title">{item.title}</h3>
          
          </div>
        ))}
      </div>

      {/* Upcoming Section */}
      <h2 className="section-label">Upcoming Screening Programs</h2>

      <div className="screening-grid">
        {newserviceCards.map((item, i) => (
          <div className="program-card" key={i} data-aos="fade-up" onClick={() => setActiveService(item)}>
            <img src={item.icon} alt={item.title} className="program-image" />
            <h3 className="program-title">{item.title}</h3>
            {/* <p className="program-short">Coming Soon</p> */}
          </div>
        ))}
      </div>

      {/* Modal */}
      {activeService && (
        <div className="modal-overlay" onClick={() => setActiveService(null)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <img src={activeService.image} alt="" className="modal-img" />
            <h3 className="modal-title">{activeService.title}</h3>

      <ul className="modal-list">
{Array.isArray(activeService.description) ? (
  <ul className="modal-list">
    {activeService.description.map((pt, idx) => (
      <li key={idx}>{pt}</li>
    ))}
  </ul>
) : (
  <p className="modal-text">{activeService.description}</p>
)}
</ul>
            <button className="modal-close" onClick={() => setActiveService(null)}>
              Close
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default ScreeningSection;
